import { OrganisationOffboardingResponse, OffboardOrganisationRequest } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';

export interface OffboardOrganisationResult {
  displayName: string;
  isOffboardingComplete: boolean;
  warnings: string[];
}

export interface OffboardOrganisationPayload {
  organisationDisplayName: string;
}

export default class OffboardOrganisation extends BaseAdapter<OrganisationOffboardingResponse> {
  rawResponse: OrganisationOffboardingResponse;

  modifiedRequest: OffboardOrganisationRequest;

  async adaptResponse(payload: OffboardOrganisationPayload): Promise<OffboardOrganisationResult> {
    await this.fetchApiResponse('/api/admin/organisation/offboard', HTTPMethod.Post, {
      organisation_auth_identifier: payload.organisationDisplayName,
    });

    return {
      displayName: this.rawResponse.display_name,
      isOffboardingComplete: this.rawResponse.is_offboarding_complete,
      warnings: this.rawResponse.warnings,
    };
  }

  adaptRequest(payload: OffboardOrganisationPayload): OffboardOrganisationRequest {
    this.modifiedRequest = {
      organisation_display_name: payload.organisationDisplayName,
    };
    return this.modifiedRequest;
  }
}
